import VSpeedDial from "vuetify/lib/components/VSpeedDial/VSpeedDial"

export default {
  name: "v-speed-dial-horus",
  extends: VSpeedDial,
  render(h) {
    let children = []
    const data = {
      class: this.classes,
    }

    if (this.openOnHover) {
      data.on.mouseenter = () => this.isActive = true

      data.on.mouseleave = () => this.isActive = false
    }

    if (this.isActive) {
      let btnCount = 0
      children = (this.$slots.default || []).map((b, i) => {
        if (b.tag && typeof b.componentOptions !== "undefined" && (b.componentOptions.Ctor.options.name === "v-btn" || b.componentOptions.Ctor.options.name === "v-tooltip")) {
          btnCount++
          return h("div", {
            style: {
              transitionDelay: btnCount * 0.05 + "s",
            },
            key: i,
          }, [b])
        } else {
          b.key = i
          return b
        }
      })
    }

    const list = h("transition-group", {
      class: "v-speed-dial__list",
      attrs: {
        id: "speed-dial-list",
      },
      props: {
        name: this.transition,
        mode: this.mode,
        origin: this.origin,
        tag: "div",
      },
    }, children)
    return h("div", data, [this.$slots.activator, list])
  },
}
